<div
  class="timer-container resize-safe"
  [ngClass]="{ modern: isModernTheme, classic: !isModernTheme }"
  resize-safe="resize-safe"
  *ngIf="timerState.isRunning || timerState.isPaused"
  cdkDrag
  [cdkDragConstrainPosition]="constrainPosition"
>
  <div class="timer-content">
    <i class="pi pi-ellipsis-v drag-handle" cdkDragHandle></i>

    <div class="task-info">
      <div
        class="project-name clickable"
        [title]="timerState.projectName"
        (click)="navigateToProject()"
      >
        {{ timerState.projectName }}
      </div>
      <div
        class="task-name clickable"
        [title]="timerState.taskName"
        (click)="navigateToTask()"
      >
        {{ timerState.taskName }}
      </div>
    </div>

    <div class="timer-center">
      <div
        class="recording-dot"
        [ngClass]="{
          pulsing: !timerState.isPaused,
          paused: timerState.isPaused
        }"
      ></div>
      <div class="timer-display">{{ formatTime(timerState.elapsedTime) }}</div>
    </div>

    <div class="timer-controls">
      <button
        class="control-btn pause-btn"
        (click)="onPauseResume()"
        [title]="timerState.isPaused ? 'Resume' : 'Pause'"
      >
        <i
          class="pi"
          [ngClass]="timerState.isPaused ? 'pi-play' : 'pi-pause'"
        ></i>
      </button>
      <button class="control-btn stop-btn" (click)="onStop()" title="Stop">
        <i class="pi pi-stop"></i>
      </button>
    </div>
  </div>
</div>
